export const DEFAULT_EXCEL_FIELD_WIDTH = '100px';
export const DEFAULT_EXCEL_FIELD_HEIGHT = 24;
